import { Actions as StreamApiActions } from '../actions/streamApi';
import { Dispatch } from 'redux';
import { isStompChannel } from '../config/websocketChannels';
import streamStompMiddleware from './streamStompMiddleware';
import streamApiMiddleware from './streamApiMiddleware';
import { Actions as AppActions } from '../actions/app';

const streamServiceMiddleware = (store: { getState; dispatch: Dispatch }) => (
  next: (action: any) => any
) => (action: any) => {
  if (process.env.REACT_APP_STREAM_SERVICE_STOMP_URL) {
    if (
      action.type === AppActions.ACCESS_TOKEN_UPDATED ||
      action.type === AppActions.RESET_SOCKET_CONNECTION
    ) {
      streamStompMiddleware(store)(next)(action);
      return streamApiMiddleware(store)(next)(action);
    }

    if (
      action.type === StreamApiActions.SEND_MESSAGE &&
      action.data?.channel &&
      isStompChannel(action.data.channel)
    ) {
      return streamStompMiddleware(store)(next)(action);
    }
  }

  return streamApiMiddleware(store)(next)(action);
};

export default streamServiceMiddleware;
